var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('not-found',{attrs:{"artist":_vm.artist,"page":_vm.page}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }